module.exports = __webpack_public_path__ + "static/img/logoIcon.9c777bd4.png";